import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Entry point from index.html
 *
 * @copyright Roche 2022
 * @author Nick Draper
 */

const RESIZE_OBSERVER_ERRORS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
];

const isResizeObserverError = (message) =>
  typeof message === "string" &&
  RESIZE_OBSERVER_ERRORS.some((known) => message.includes(known));

window.addEventListener("error", (event) => {
  if (!isResizeObserverError(event.message)) {
    return;
  }
  event.stopImmediatePropagation();
  event.preventDefault();

  // The webpack-dev-server client registers its own error listener before the app
  // bundle loads, so stopImmediatePropagation cannot be guaranteed to run first.
  // Hide the dev overlay directly as a fallback.
  const overlay = document.getElementById("webpack-dev-server-client-overlay");
  const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
  if (overlay) {
    overlay.style.display = "none";
  }
  if (overlayDiv) {
    overlayDiv.style.display = "none";
  }
});

const AppEntry = () => {
  return <StrictMode><App /></StrictMode>
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppEntry />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
